module.exports = __webpack_public_path__ + "img/tooltip.25f4944e.svg";